import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../../../../function/helper";

const doSubmit = async (values, loading, set, close) => {
  const response = await postRequestByAuth(
    "/address/v1/external/add-address",
    values
  );

  if (response) {
    Swal.fire({
      icon: response.status === 200 ? "success" : "warning",
      text: response.data.message,
      confirmButtonText: "متوجه شدم",
    });

    if (response.status === 200) {
      set(response.data.address);
      close();
    }

    loading();
  }
};

export default doSubmit;
